import React from 'react';
import classnames from 'classnames';

const Discount = (props) => {
  const { label, value, subtotal, alwaysShow } = props;

  if (!alwaysShow && (value === undefined || value == null)) return null;

  return (
    <>
      <div>
        <span>Subtotal :</span>
        <span className="cart-amount order-subtotal">{subtotal}</span>
      </div>
      <div>
        <span>{label || 'Discount'}:</span>
        <span className="cart-amount product-discount">{value}</span>
      </div>
    </>
  );
};

const CartComponent = (props) => {
  const {
    unitPrice,
    totalPrice,
    onAddToCart,
    properties = [],
    disabled,
    loading,
    btnLabel,
    discountLabel,
    discountValue,
    discountSubtotal,
    discountAlwaysShow,
  } = props;

  const onClick = () => {
    if (onAddToCart) {
      onAddToCart();
    }
  };
  const unitPriceClassName = classnames('cart-amount unit-price', {
    discounted: discountValue,
  });

  return (
    <div className="product-tabs-cart px-4 py-3">
      <span className="selection-label">
        Pricing Information
        :
      </span>
      <hr />

      <div>
        {properties.map((property, i) => (
          <div
            key={i}
            className="properties g-0 align-items-center py-1">
            <div>
              <span className="">{property.label}</span>
            </div>
            <div>
              <span className="">{property.value}</span>
            </div>
          </div>
        ))}
      </div>

      <div className="prices-section">
        <div className="border border-right-0 border-left-0 py-1">
          <span>
            Unit Price:&nbsp;
          </span>
          <span className={unitPriceClassName}>
            {unitPrice ? `$${unitPrice?.toFixed(2)}` : null}
          </span>
        </div>
        <Discount
          label={discountLabel}
          value={discountValue}
          subtotal={discountSubtotal}
          alwaysShow={discountAlwaysShow} />

        <div className="total">
          <span className="product-total-label">
            Total:&nbsp;
          </span>
          <span className="product-total">
            {totalPrice ? `$${totalPrice?.toFixed(2)}` : null}
          </span>
        </div>
      </div>
      <div className="text-center">
        <button
          type="button"
          disabled={disabled || loading}
          className="btn btn-primary w-100"
          onClick={onClick}>
          {loading && <span className="spinner-border spinner-border-sm mr-2" aria-hidden="true" />}
          {loading ? Spree.translations.adding_to_cart : btnLabel}
        </button>
      </div>
    </div>
  );
};

CartComponent.defaultProps = {
  btnLabel: Spree.translations.add_to_cart,
};

export default CartComponent;
